import type { Components } from '@mui/material/styles';

export default function MuiImageListItem(): Components['MuiImageListItem'] {
  return {};
}
